/**
 * @generated SignedSource<<59b4b923220975b69240d2d8526c458d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ViewsProvider_gql$data = {
  readonly allViews: ReadonlyArray<{
    readonly alias?: string;
    readonly databaseId?: number;
    readonly description?: string | null | undefined;
    readonly id?: string;
    readonly name?: string;
    readonly peopleFilters?: any;
    readonly projectFilters?: any;
    readonly type?: string;
    readonly userIds?: ReadonlyArray<number>;
  }>;
  readonly features_accounts: ReadonlyArray<{
    readonly enabled: boolean;
    readonly feature_id: string;
  }>;
  readonly selectedView: {
    readonly alias?: string;
    readonly databaseId?: number;
    readonly isCoerced?: boolean;
    readonly type?: string;
  } | null | undefined;
  readonly " $fragmentType": "ViewsProvider_gql";
};
export type ViewsProvider_gql$key = {
  readonly " $data"?: ViewsProvider_gql$data;
  readonly " $fragmentSpreads": FragmentRefs<"ViewsProvider_gql">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "alias",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCoerced",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ViewsProvider_gql",
  "selections": [
    {
      "alias": "allViews",
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "availableViews",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "projectFilters",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "peopleFilters",
              "storageKey": null
            }
          ],
          "type": "AvailableViewInterface",
          "abstractKey": "__isAvailableViewInterface"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "userIds",
              "storageKey": null
            }
          ],
          "type": "DatabaseView",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v1/*: any*/),
            (v3/*: any*/)
          ],
          "type": "VirtualView",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "selectedView",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            (v2/*: any*/),
            (v4/*: any*/)
          ],
          "type": "SelectedDatabaseView",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v3/*: any*/),
            (v4/*: any*/)
          ],
          "type": "SelectedVirtualView",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "features_accounts",
      "kind": "LinkedField",
      "name": "features_accounts",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "feature_id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "query_root",
  "abstractKey": null
};
})();

(node as any).hash = "1366a546f2b8a920bfffe85d04778238";

export default node;
